"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M42 20h-2a16 16 0 0 0-32 0H6a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h6V20h-.1a12.1 12.1 0 0 1 24.2 0H36v15.117a13.951 13.951 0 0 1-8.54 6.4A4.338 4.338 0 0 0 24 40c-2.209 0-4 1.343-4 3s1.791 3 4 3c1.977 0 3.609-1.078 3.932-2.492A16 16 0 0 0 37.826 36H42a4 4 0 0 0 4-4v-8a4 4 0 0 0-4-4z" })
);

